module.exports = __webpack_public_path__ + "media/audio15.7091164c.wav";